import { useMutation } from "@tanstack/react-query";
import { useShallow } from "zustand/shallow";
import { useUIStore } from "../stores/ui-store";
import { UIState } from "../types/ui-types";
import { useTranslation } from "react-i18next";
import { fetchCompanyFullProductData } from "../api/fullProductData.api";

const useProductPackageRowPrices = () => {
  const { t } = useTranslation();
  const [bearerToken, toast] = useUIStore(
    useShallow((state: UIState) => [state.bearerToken, state.toastRef])
  );

  const getProductPrices = async (
    companyId: string,
    productIdentifier: string
  ) => {
    return await getProductPricesMutation.mutateAsync({
      companyId,
      productIdentifier,
    });
  };

  const getProductPricesMutation = useMutation({
    mutationFn: (payload: { companyId: string; productIdentifier: string }) =>
      fetchCompanyFullProductData(
        bearerToken as string,
        parseInt(payload.companyId, 10),
        [payload.productIdentifier]
      ),
    onSuccess: (data) => {
      // Handle success, e.g., update state or notify user
    },
    onError: (error) => {
      toast?.current?.show({
        severity: "error",
        detail: t("combine-error"),
      });
    },
  });

  return {
    error: getProductPricesMutation.error,
    isPending: getProductPricesMutation.isPending,
    getProductPrices,
  };
};

export default useProductPackageRowPrices;
